import React from "react";
import ReactTooltip from "react-tooltip";
import cx from "classnames";
import { nanoid } from "nanoid";
import PropTypes from "prop-types";

import { isMobileDevice } from "utils";

import styles from "./Tooltip.css";

export default class Tooltip extends React.Component {
  constructor(props) {
    super(props);
    this.tooltip = null;
    this.state = {
      tip: props.tip,
      tooltip: props.children || props.tooltip,
    };
    this.handleOnClick = this.handleOnClick.bind(this);
    this.handleAfterHide = this.handleAfterHide.bind(this);
    this.handleOnTouchEnd = this.handleOnTouchEnd.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      tooltip: nextProps.children || nextProps.tooltip,
      tip: nextProps.tip,
    });
  }

  handleAfterHide() {
    if (!this.props.tooltipAfterClick) return;
    this.setState({ tooltip: this.props.children || this.props.tooltip });
  }

  handleOnClick() {
    if (!this.props.tooltipAfterClick) return;
    this.setState({ tooltip: this.props.tooltipAfterClick });
  }

  handleOnTouchEnd() {
    if (this.props.tipAfterClick) {
      this.setState({ tip: this.props.tipAfterClick });
      setTimeout(() => {
        this.setState({ tip: this.props.tip });
      }, 2000);
    }
  }

  render() {
    const {
      afterShow,
      delayShow,
      event,
      header,
      isActionable,
      keepOpen,
      place,
      tip,
      tooltipAfterClick,
    } = this.props;
    const id = nanoid();
    const content = (
      <div>
        {header ? <div className={styles.header}>{header}</div> : null}
        <div className={styles.content}>{this.state.tooltip}</div>
      </div>
    );

    return isMobileDevice() ? (
      <div onTouchEnd={this.handleOnTouchEnd}>{this.state.tip}</div>
    ) : (
      <div
        className={cx(styles.root, {
          [styles.largePadding]: header,
          [styles.actionable]: isActionable,
        })}
      >
        <div
          className={styles.tip}
          data-for={id}
          data-tip
          {...(tooltipAfterClick && { onClick: this.handleOnClick })}
        >
          {tip}
        </div>
        <ReactTooltip
          afterShow={afterShow}
          className={cx("tooltip", { [styles.keepOpen]: keepOpen })}
          delayHide={keepOpen ? 251 : 0}
          delayShow={delayShow}
          effect="solid"
          event={event}
          getContent={[() => content, 200]}
          globalEventOff={event}
          id={id}
          place={place}
          {...(tooltipAfterClick && { afterHide: this.handleAfterHide })}
        />
      </div>
    );
  }
}

Tooltip.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  header: PropTypes.string,
  tip: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  tooltipAfterClick: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  tipAfterClick: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  event: PropTypes.oneOf(["click"]),
  place: PropTypes.oneOf(["top", "right", "bottom", "left"]),
  delayShow: PropTypes.number,
  afterShow: PropTypes.func,
  keepOpen: PropTypes.bool,
  isActionable: PropTypes.bool,
};

Tooltip.defaultProps = {
  place: "bottom",
};
